import React, { FC } from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../../constants/aampeTheme';

const FakeMenuBar: FC<React.PropsWithChildren<unknown>> = () => {
    return (
        <Bar>
            <StyledImage src="https://storage.googleapis.com/assets.aampe.com/app_images/preview_assets/web_push_bar_icons.svg" />
        </Bar>
    );
};

export default FakeMenuBar;

const Bar = styled.div({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    backgroundColor: aampeTheme.colors.bordersWG01,
    width: '100%',
    height: '30px',
    borderRadius: '0 16px 0 0',
});

const StyledImage = styled.img({
    height: '100%',
});
